import styled, { keyframes } from 'styled-components';

const SpinnerAnimation = keyframes`
0%,
100% {
  box-shadow: 0em -2.6em 0em 0em #6C757D, 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2), 2.5em 0em 0 0em rgba(108, 117, 125, 0.2), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.2), 0em 2.5em 0 0em rgba(108, 117, 125, 0.2), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.2), -2.6em 0em 0 0em rgba(108, 117, 125, 0.5), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.7);
}
12.5% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.7), 1.8em -1.8em 0 0em #6C757D, 2.5em 0em 0 0em rgba(108, 117, 125, 0.2), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.2), 0em 2.5em 0 0em rgba(108, 117, 125, 0.2), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.2), -2.6em 0em 0 0em rgba(108, 117, 125, 0.2), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.5);
}
25% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.5), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.7), 2.5em 0em 0 0em #6C757D, 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.2), 0em 2.5em 0 0em rgba(108, 117, 125, 0.2), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.2), -2.6em 0em 0 0em rgba(108, 117, 125, 0.2), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2);
}
37.5% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.2), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.5), 2.5em 0em 0 0em rgba(108, 117, 125, 0.7), 1.75em 1.75em 0 0em #6C757D, 0em 2.5em 0 0em rgba(108, 117, 125, 0.2), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.2), -2.6em 0em 0 0em rgba(108, 117, 125, 0.2), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2);
}
50% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.2), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2), 2.5em 0em 0 0em rgba(108, 117, 125, 0.5), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.7), 0em 2.5em 0 0em #6C757D, -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.2), -2.6em 0em 0 0em rgba(108, 117, 125, 0.2), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2);
}
62.5% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.2), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2), 2.5em 0em 0 0em rgba(108, 117, 125, 0.2), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.5), 0em 2.5em 0 0em rgba(108, 117, 125, 0.7), -1.8em 1.8em 0 0em #6C757D, -2.6em 0em 0 0em rgba(108, 117, 125, 0.2), -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2);
}
75% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.2), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2), 2.5em 0em 0 0em rgba(108, 117, 125, 0.2), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.2), 0em 2.5em 0 0em rgba(108, 117, 125, 0.5), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.7), -2.6em 0em 0 0em #6C757D, -1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2);
}
87.5% {
  box-shadow: 0em -2.6em 0em 0em rgba(108, 117, 125, 0.2), 1.8em -1.8em 0 0em rgba(108, 117, 125, 0.2), 2.5em 0em 0 0em rgba(108, 117, 125, 0.2), 1.75em 1.75em 0 0em rgba(108, 117, 125, 0.2), 0em 2.5em 0 0em rgba(108, 117, 125, 0.2), -1.8em 1.8em 0 0em rgba(108, 117, 125, 0.5), -2.6em 0em 0 0em rgba(108, 117, 125, 0.7), -1.8em -1.8em 0 0em #6C757D;
}`;
export const Spinner = styled.div <{ size: number }>`
  color: #6c757d;
  margin: 100px auto;
  font-size: ${(props) => (props.size ? `${props.size / 4}px` : '4px')};
  width: ${(props) => (props.size ? `${props.size / 3}px` : '5px')};
  height: ${(props) => (props.size ? `${props.size / 3}px` : '5px')};
  margin: 0px;
  margin-right: 6px;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  animation: ${SpinnerAnimation} 1.5s infinite ;
`;
const FileUploadContainer = styled.section`
  display: -ms-flexbox;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  height: -moz-fit-content;
  width: 100%;
  place-content: center;
  max-width: 210px;
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  position: relative;
  img {
    margin-right: 10px;
  }
`;

const FormField = styled.input`
  font-size: 18px;
  display: block;
  width: 100%;
  max-width: 210px;
  height: 48px;
  font-size: 14px;
  line-height: 20px;
  border: none;
  text-transform: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

const InputLabel = styled.label`
  top: -21px;
  font-size: 13px;
  color: black;
  left: 0;
  position: absolute;
`;

const DragDropText = styled.p`
  font-weight: bold;
  letter-spacing: 1.5px;
  text-align: center;
`;

const UploadFileBtn = styled.button<{invalid: boolean}>`
  box-sizing: border-box;
  appearance: none;
  background-color: transparent;
  border: 2px solid #dee2e6;
  cursor: pointer;
  padding: 11px 10px;
  text-align: center;
  font-weight: 500;
  transition: color 250ms ease-in-out;

  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  min-width: 100%;
  border: 2px solid #dee2e6;
  background-color: #ffffff;
  color: #6c757d;
  position: relative;
  overflow: hidden;
  max-width: 210px;
  font-size: 14px;
  line-height: 20px;
  transition: all 350ms ease-out;
  ${(props) => props.invalid && `
    border: 1px solid #FCD6D8;
    background-color: #FDEAEB;
  `};
  &:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 100%;
    color: #fff;
    background: #0055fb;
    z-index: -1;
  }

  &:hover {
    outline: 0;
    background: #dee2e6;
  }

  &:focus {
    outline: 0;
    background: transparent;
  }

  &:disabled {
    opacity: 0.4;
    filter: grayscale(100%);
    pointer-events: none;
  }
`;

const RemoveFileIcon = styled.i`
  cursor: pointer;
  font-style: normal;
  font-weight: 800;

  &:hover {
    transform: scale(1.3);
  }
`;

const TextDescription = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6c757d;
  margin-top: 6px;
  color: #6c757d;
`;

const Shimer = styled.div`
  @keyframes placeholderShimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }

  border-radius: 8px;
  width: 100%;
  height: 400px;
  background: #e6e6e6;
  background-image: linear-gradient(to right, #e6e6e6 0%, #d8d8d8 20%, #e6e6e6 40%, #e6e6e6 100%);
  background-repeat: no-repeat;
  background-size: 800px 304px;
  display: inline-block;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeholderShimmer;
  animation-timing-function: linear;
`;

const TextTitle = styled.div`
  margin-bottom: 8px;
  color: #000000;
`;

const CircleWhite = styled.span`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: inline-block;
  background: #ffffff;
  border: 1px solid #dee2e6;
  box-sizing: border-box;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  text-align: center;
  transform: translate(-110%, 8%);
  position: absolute;
  z-index: 100;
`;

export {
  FileUploadContainer,
  FormField,
  InputLabel,
  DragDropText,
  UploadFileBtn,
  RemoveFileIcon,
  TextDescription,
  Shimer,
  TextTitle,
  CircleWhite,
};
